//libraries
import Vue from 'vue'

const state = {

}

//functions receive state
const getters = {

}

//functions receive context and params
const actions = {
  async upload_file ({ commit }, params) {
    try {
      let res = await Vue.request.post(`upload/file`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error cargando archivos`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error cargando archivos`})
      console.error(e)
    }
  },
  async send_audio ({ commit }, { params = {}, callback = () => {} }) {
    try {
      const res = await Vue.request.post('upload/process/audio', params)
      const { data } = res

      if (!data.success) throw new Error('Ocurrió un error enviando el audio.')

      return callback(data)
    } catch (e) {
      console.error(e)

      const data = { error: e.message }

      return callback(data)
    }
  },
  async upload_private_file ({ commit }, params) {
    try {
      let res = await Vue.request.post(`upload/privateFile`, params)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error cargando archivos`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error cargando archivos`})
      console.error(e)
    }
  },
  async zip_code ({ commit }, params) {
    try {
      let res = await Vue.request.get(`utils/zipcode/${params.zipcode}`)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error obteniendo localidades`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error obteniendo localidades`})
      console.error(e)
    }
  },
  async validate_clabe ({ commit }, params) {
    try {
      let res = await Vue.request.get(`utils/validateClabe/${params.clabe}`)
      if(res.data.success && params.callback) {
        params.callback(res.data)
      } else if (params.callback) {
        params.callback({error: `Error validando clabe`})
      }
    } catch (e) {
      if(params.callback)
        params.callback({error: `Ocurrió un error validando clabe`})
      console.error(e)
    }
  }
}

//functions receive state
const mutations = {

}

export default {
  state,
  mutations,
  actions,
  getters
}
